<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="22.189" height="22.61" viewBox="0 0 22.189 22.61">
    <g transform="translate(-1035.662 -576.494)">
      <g>
        <circle
          cx="7"
          cy="7"
          r="7"
          transform="translate(1043.851 584.741)"
          fill="none"
        />
        <path
          d="M1050.851,598.741a7,7,0,1,1,7-7A7.008,7.008,0,0,1,1050.851,598.741Zm0-13a6,6,0,1,0,6,6A6.007,6.007,0,0,0,1050.851,585.741Z"
        />
      </g>
      <path
        d="M1053.819,584.611l-1-.023c.135-5.7-3.207-7-6.033-7.1-6.18.407-5.9,6.445-5.886,6.7l-1,.061c-.005-.072-.363-7.286,6.867-7.761C1049.5,576.58,1053.981,577.749,1053.819,584.611Z"
      />
      <path
        d="M1044.792,599.1a4.043,4.043,0,0,1-.882-.113,10.711,10.711,0,0,1-6.9-5.057,10.21,10.21,0,0,1-1.073-7.4,3.261,3.261,0,0,1,1.329-2.151,2.631,2.631,0,0,1,2.352-.074,12.588,12.588,0,0,1,4.55,3.092.5.5,0,1,1-.73.684,11.582,11.582,0,0,0-4.178-2.843,1.708,1.708,0,0,0-1.479,0,2.305,2.305,0,0,0-.862,1.481,9.244,9.244,0,0,0,.958,6.718,9.7,9.7,0,0,0,6.257,4.58c.816.186,1,.022,1,.021a.227.227,0,0,0,0-.14.505.505,0,0,1,.336-.618.5.5,0,0,1,.618.318,1.178,1.178,0,0,1-.216,1.113A1.373,1.373,0,0,1,1044.792,599.1Z"
      />
      <rect
        width="12.9"
        height="1"
        transform="translate(1040.396 583.024)"
      />
      <rect
        width="1"
        height="8.26"
        transform="translate(1046.358 576.993)"
      />
      <path
        d="M1044.3,585.512l-.961-.278c.841-2.921-1.62-5.871-1.645-5.9l.762-.647C1042.576,578.822,1045.294,582.068,1044.3,585.512Z"
      />
      <path
        d="M1049.1,584.524c-.653-3.173,2.16-5.775,2.279-5.884l.674.739c-.026.023-2.51,2.333-1.973,4.944Z"
      />
      <path
        d="M1051.125,588.81l-2.839-1.379.739-2.216.949.316-.462,1.384,1.519.738,1.518-1.067-.372-1.048.941-.336.628,1.765Z"
      />
      <path
        d="M1055.957,593.341l-1.979-2.244.521-3.169h2.024v1h-1.175l-.306,1.862,1.118,1.27,1.128-.668.51.861Z"
      />
      <path
        d="M1052.314,598.426l-1.16-1.424,1.709-2.615,2.82-.272.866,1.591-.879.479-.55-1.011-1.684.163-1.047,1.6.7.857Z"
      />
      <path
        d="M1048.972,598.247l-.711-.7.688-.694-.308-1.5-1.538-.295-1.065,1.395-.795-.607,1.44-1.885,2.8.537.55,2.677Z"
      />
      <path
        d="M1045.663,592.952l-1.575-1.014.541-.842.968.623,1.242-1.007-.245-1.713-1.5-.274.18-.984,2.207.405.427,2.986Z"
      />
      <path
        d="M1052.941,592.082l-2.415-1.407v-2.441h1V590.1l1.5.872,1.591-.64.373.928Z"
      />
      <path
        d="M1052.913,595.394l-1.336-1.857,1-2.326.918.395-.775,1.807,1.006,1.4Z"
      />
      <path
        d="M1048.959,595.453l-.711-.7,1.576-1.593h2.365v1h-1.947Z"
      />
      <path
        d="M1049.3,594.021l-.752-3.2,2.406-1.087.412.912-1.656.747.563,2.4Z"
      />
      <rect
        width="1"
        height="2.216"
        transform="translate(1047.229 591.261) rotate(-73.194)"
      />
      <path
        d="M1036.557,589.435l-.786-.62a8.612,8.612,0,0,1,6.059-3.248l.08,1A7.6,7.6,0,0,0,1036.557,589.435Z"
      />
      <path
        d="M1041.1,597.773l-.319-.947a17.741,17.741,0,0,0,3.256-1.48l.5.863A18.6,18.6,0,0,1,1041.1,597.773Z"
      />
      <rect
        width="1"
        height="5.389"
        transform="translate(1039.713 589.367) rotate(-28.939)"
      />
      <rect
        width="2.43"
        height="0.999"
        transform="matrix(0.895, -0.446, 0.446, 0.895, 1039.47, 590.118)"
      />
      <rect
        width="2.465"
        height="0.999"
        transform="translate(1040.157 591.612) rotate(-28.619)"
      />
      <rect
        width="2.398"
        height="1"
        transform="matrix(0.886, -0.463, 0.463, 0.886, 1040.941, 592.812)"
      />
      <rect
        width="1"
        height="1.793"
        transform="translate(1038.174 593.287) rotate(-37.163)"
      />
      <rect
        width="0.999"
        height="0.68"
        transform="matrix(0.735, -0.678, 0.678, 0.735, 1039.783, 595.44)"
      />
    </g>
  </svg>
</template>
